import React from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const PercentageCurrencyType = ({
  open,
  setOpen,
  handleCurrencyTypeChange,
  setCurrencyType,
  CurrencyType,
  handleSave,
}) => {
  return (
    <GlobalDialog
      title={"Select Currency Type"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      fullWidth
      maxWidth={"sm"}
      content={
        <>
          {open ? (
            <Box>
              <Box>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Currency Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    required
                    value={CurrencyType}
                    label="Currency Type"
                    onChange={handleCurrencyTypeChange}
                  >
                    <MenuItem value={1}>INR</MenuItem>
                    <MenuItem value={2}>AED</MenuItem>
                    <MenuItem value={3}>AED To INR</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
          ) : null}
          <Box sx={{ display: "flex", justifyContent: "center", pt: 1 }}>
            <Button
              size={"small"}
              onClick={handleSave}
              sx={{
                color: "white",
                background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                borderRadius: 3,
              }}
            >
              Proceed
            </Button>
          </Box>
        </>
      }
    />
  );
};

export default PercentageCurrencyType;
